var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "job-post-detail-modal" },
    [
      _c(
        "sweet-modal",
        {
          ref: "modal",
          attrs: { "overlay-theme": "light", allowfullscreen: "" }
        },
        [
          _vm.jobPost
            ? _c(
                "section",
                { staticClass: "main-content bg-light text-left" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 p-0" }, [
                      _c("section", { staticClass: "bg-white p-3" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex text-secondary text-small" },
                          [
                            _c("div", { staticClass: "flex-fill" }, [
                              _vm._v(
                                "\n                Job #" +
                                  _vm._s(_vm.jobPost.code) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex-fill text-right" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("prettyDate")(_vm.jobPost.created_at)
                                  ) +
                                  "\n              "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "py-3 text-center" }, [
                          _c("div", { staticClass: "job-post-title" }, [
                            _vm._v(_vm._s(_vm.jobPost.title))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "job-post-salary -status-alert mt-2"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("currency")(_vm.jobPost.min_salary)
                                  ) +
                                  " - " +
                                  _vm._s(
                                    _vm._f("currency")(_vm.jobPost.max_salary)
                                  ) +
                                  " / เดือน\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-4" }, [
                            _c("i", {
                              staticClass: "fas fa-map-marker-alt -status-alert"
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("multiLangName")(
                                    _vm.jobPost.address_province
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("multiLangName")(_vm.jobPost.district)
                                ) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.jobPost.job_users.length > 0
                            ? _c("div", { staticClass: "mt-2" }, [
                                _c("i", { staticClass: "fas fa-user" }),
                                _vm._v(
                                  " มี " +
                                    _vm._s(_vm.jobPost.job_users.length) +
                                    " คนสนใจ\n              "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("section", { staticClass: "bg-white p-3 mt-3" }, [
                        _c("h3", [_vm._v("สวัสดิการ")]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", [_c("label", [_vm._v("ที่พัก")])]),
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.jobPost.has_accommodation === 0
                                  ? "ไม่มีที่พักให้ (ไป-กลับ)"
                                  : "มีที่พักให้"
                              ) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.jobPost.job_post_welfares.length > 0
                          ? _c("div", { staticClass: "mt-3" }, [
                              _c("div", [
                                _c("label", [_vm._v("สวัสดิการอื่น ๆ")])
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "pl-4" },
                                _vm._l(_vm.jobPost.job_post_welfares, function(
                                  item,
                                  index
                                ) {
                                  return _c("li", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.job_welfare.name) +
                                        "\n                "
                                    )
                                  ])
                                }),
                                0
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("section", { staticClass: "bg-white p-3 mt-3" }, [
                        _c("h3", [_vm._v("คุณสมบัติ")]),
                        _vm._v(" "),
                        _vm.jobPost.job_post_skills.length > 0
                          ? _c("div", { staticClass: "mt-3" }, [
                              _c("div", [
                                _c("label", [_vm._v("ทักษะที่ต้องการ")])
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "pl-4" },
                                _vm._l(_vm.jobPost.job_post_skills, function(
                                  item,
                                  index
                                ) {
                                  return _c("li", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.job_skill.name) +
                                        "\n                "
                                    )
                                  ])
                                }),
                                0
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.jobPost.job_post_languages.length > 0
                          ? _c("div", { staticClass: "mt-3" }, [
                              _c("div", [_c("label", [_vm._v("ภาษา")])]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "pl-4 mb-0" },
                                _vm._l(_vm.jobPost.job_post_languages, function(
                                  item,
                                  index
                                ) {
                                  return _c("li", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.language.name) +
                                        "\n                "
                                    )
                                  ])
                                }),
                                0
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("section", { staticClass: "bg-white p-3 mt-3" }, [
                        _c("h3", [_vm._v("รายละเอียดงาน")]),
                        _vm._v(" "),
                        _c("div", {
                          directives: [
                            { name: "linkified", rawName: "v-linkified" }
                          ],
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.handleNewLine(_vm.jobPost.description)
                            )
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { style: "height: " + _vm.footerHeight + "px;" }, [
                    _vm._v(" ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "sectionFooter",
                      staticClass: "bg-white border-top p-2",
                      class: { "bottom-button": !_vm.$mq.desktop }
                    },
                    [
                      _vm.jobUser
                        ? _c("div", [
                            !_vm.isInterestedJob(_vm.jobPost)
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-lg btn-outline-secondary btn-block p-2",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.openModalConfirm.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-plus" }),
                                    _vm._v(" สนใจรับงานนี้\n          ")
                                  ]
                                )
                              : _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-lg btn-info btn-block p-2",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteData()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-check" }),
                                    _vm._v(
                                      " ลงชื่อสนใจรับงานนี้แล้ว\n          "
                                    )
                                  ]
                                )
                          ])
                        : _c("div", [
                            _c("div", { staticClass: "text-center" }, [
                              _c("span", { staticClass: "text-small" }, [
                                _vm._v(
                                  "\n               ล็อกอิน หรือลงทะเบียนระบบ BeNeat Jobs"
                                ),
                                _c("br"),
                                _vm._v(
                                  "เพื่อสามารถกดสนใจรับงานนี้ได้\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "py-3" }, [
                                _vm.apiUrl
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-success",
                                        attrs: { href: _vm.apiUrl }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "d-inline-block pl-2"
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fab fa-line fa-lg"
                                            })
                                          ]
                                        ),
                                        _vm._v(
                                          "  ล็อคอิน/ลงทะเบียน BeNeat Jobs ผ่าน LINE\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-lg btn-outline-secondary btn-block p-2",
                                attrs: { disabled: "" }
                              },
                              [
                                _c("i", { staticClass: "fas fa-plus" }),
                                _vm._v(" สนใจรับงานนี้\n          ")
                              ]
                            )
                          ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("sweet-modal", { ref: "modalConfirm" }, [
        _c("h3", [_vm._v("ยืนยันสมัครงานประจำ")]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _vm._v("\n        Job #" + _vm._s(_vm.jobPost.code) + "\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("h5", { staticClass: "card-title" }, [_vm._v("หมายเหตุ")]),
            _vm._v(" "),
            _c("p", { staticClass: "card-text text-left text-danger" }, [
              _c("span", [
                _vm._v(
                  "\n          - ผู้สมัครยินยอมให้ส่งข้อมูลส่วนบุคคลใดๆ ก็ตามที่ได้กรอกผ่านแพลตฟอร์มนี้ทั้งหมด เพื่อให้ลูกค้าได้พิจารณาเลือกสัมภาษณ์ "
                ),
                _c("br"),
                _vm._v(
                  "\n          - ผู้สมัครยืนยันว่าข้อมูลที่กรอกเข้ามาเป็นข้อมูลจริงทั้งหมด และยอมรับการพิจารณาของ BeNeat หากตรวจพบข้อมูลเท็จ\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "a",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { "margin-right": "10rem" },
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.addData()
                    }
                  }
                },
                [_vm._v("ยืนยัน")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-danger",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.$refs.modalConfirm.close()
                    }
                  }
                },
                [_vm._v("ยกเลิก")]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("update-profile-modal", { ref: "updateProfileModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6305c9a1", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6305c9a1","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobPost/JobPostDetailModal.vue
// module id = 2338
// module chunks = 0